import { api } from 'app/config/apiConfig';
import { RejectDocumentReason, VerificationDocument } from '../model/types';

export interface RejectVerificationPhotoArgs {
  verificationPhotoId: string;
  rejectReason: RejectDocumentReason;
  note?: Nullable<string>;
}

export const rejectVerificationPhotoApi = api.injectEndpoints({
  endpoints: (builder) => ({
    rejectVerificationPhoto: builder.mutation<VerificationDocument, RejectVerificationPhotoArgs>({
      query: ({ verificationPhotoId, ...body }) => ({
        url: `/verification-photos/${verificationPhotoId}/reject`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['VerificationDocuments', 'Users'],
    }),
  }),
});

export const { useRejectVerificationPhotoMutation } = rejectVerificationPhotoApi;
